// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__KGeAZ","buttons":"Footer_buttons__2B7Gk"};